import React, {useEffect} from 'react';
import PropTypes from 'prop-types';

import {publish} from '@stubhub/pubsub-utils';

import {EVENT_PAGE} from '../../../../tracking/track-enum';

import withContainer from './container';
import {usePrevious} from './hooks/usePrevious';
// Views
import DesktopBYO from './layouts/desktop/view';
import MobileBYO from './layouts/mobile/view';

import './index.scss';

const RoyalBuildYourOrder = (props) => {
  const {
    loading = true,
    eventLoading = true,
    isPriceLoading = true,
    deviceType,
    destroy,
    paypalClientId,
    btToken,
    listingId,
    price = {},
    byoQuantity,
  } = props;
  const prevLoading = usePrevious(loading);
  const prevEventLoading = usePrevious(eventLoading);
  const prevPriceLoading = usePrevious(isPriceLoading);
  const isFullyLoaded = !eventLoading && !loading && !isPriceLoading;
  const hasLoadChanged =
    loading !== prevLoading || eventLoading !== prevEventLoading || isPriceLoading !== prevPriceLoading;

  useEffect(() => {
    return () => destroy();
  }, [destroy]);

  useEffect(() => {
    if (isFullyLoaded && hasLoadChanged) {
      publish(EVENT_PAGE.LISTINGS, {listingId, price, byoQuantity});
    }
  }, [hasLoadChanged, isFullyLoaded, listingId, price, byoQuantity]);

  const ByoLayout = deviceType === 'phone' ? MobileBYO : DesktopBYO;
  const byo = <ByoLayout {...props} isPaypalLoading={!isFullyLoaded || !paypalClientId || !btToken} />;

  return byo;
};

RoyalBuildYourOrder.propTypes = {
  /**
   * Device type
   */
  deviceType: PropTypes.string.isRequired,

  /**
   * If is loading
   */
  loading: PropTypes.bool,

  /**
   * If event is loading
   */
  eventLoading: PropTypes.bool,

  /**
   * If price is loading
   */
  isPriceLoading: PropTypes.bool,

  /**
   * Destroy function
   */
  destroy: PropTypes.func.isRequired,

  /**
   * Paypal Client ID
   */
  paypalClientId: PropTypes.string,

  /**
   * Braintree token
   */
  btToken: PropTypes.string,

  /**
   * Listing ID
   */
  listingId: PropTypes.number,

  /**
   * Price object with amount and currency
   */
  price: PropTypes.object,

  /**
   * Quantity
   */
  byoQuantity: PropTypes.number,

  /** show map in byo? */
  showMap: PropTypes.bool,
};

RoyalBuildYourOrder.contextTypes = {
  cookies: PropTypes.object,
};

export default withContainer(RoyalBuildYourOrder);
